// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__ttCommonsFont_539f70', '__ttCommonsFont_Fallback_539f70'"},"className":"__className_539f70"};